// extracted by mini-css-extract-plugin
export default {"container":"style_container__6P5jX","img":"style_img__PDWJD","text":"style_text__mz6dV","container__error_button":"style_container__error_button__08Q8F"};